var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.91,24.48c.07-1.54-1.37-2.1-1.37-2.1l-7.97-3.43s.02-7.98,0-9.58c-.02-1.62-1.44-2.17-1.44-2.17,0,0-6.3-2.56-8.17-3.5-.97-.49-1.99,0-1.99,0,0,0-5.93,2.67-7.76,3.43-1.67.69-1.65,2.17-1.65,2.17v9.61s-5.22,2.3-7.42,3.18c-2.1.84-2.04,2.6-2.04,2.6,0,0,.02,8.08,0,9.65-.02,1.7,1.49,2.24,1.49,2.24,0,0,5.06,2.61,7.49,3.73,1.79.83,2.95.02,2.95.02l7.96-3.99s6.29,3.02,7.77,3.96c1.72,1.1,2.88.19,2.88.19,0,0,7.01-3.62,8.1-4.13,1.17-.54,1.17-1.89,1.17-1.89,0,0-.07-8.46,0-10h0Zm-29.26,3.01l-7.28-3.25,7.28-3.25,7.42,3.22-7.42,3.29Zm8.17,6.85l-7.01,3.57v-8.39l7.01-3.08v7.9Zm1.15-21.55l-7.88-3.43,7.88-3.55,8.19,3.55-8.19,3.43Zm1.25,2.1l6.94-3.08v7.2l-6.94,3.15v-7.27Zm8.28,12.59l-7.25-3.25,6.94-3.25,7.56,3.25-7.25,3.25Zm8,7.07l-6.87,3.36v-8.39l6.87-3.08v8.12h0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureIcon);
export default __webpack_public_path__ + "static/media/structure-icon.ec3dde2cb8a3b0af2b6eae005c4f8d17.svg";
export { ForwardRef as ReactComponent };